// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RPke1zj8ewHjV9TN3Otg{display:inline-block;position:relative;width:100%;max-width:100%;overflow:visible;flex-grow:1;min-width:0}.RPke1zj8ewHjV9TN3Otg.d44PY95VMKRoyYlGbsr5{width:auto;flex-grow:0}.CHFD27HlQmJL5ruUApiy{cursor:pointer;display:flex;width:100%;-webkit-tap-highlight-color:rgba(0,0,0,0)}.xqGIfJ1TkyB9wkKeLsHy{width:100%;border-radius:12px;cursor:pointer;transition:background-color .15s ease;padding:0 8px 0 4px;display:flex;align-items:center;-webkit-tap-highlight-color:rgba(0,0,0,0)}.xqGIfJ1TkyB9wkKeLsHy.xxaIlVfjH0PLAN_huz1x{background-color:#c9c9c9}.ocEleGivLeKHe3q0dCtZ{width:169px;min-width:169px;padding:10px 0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `RPke1zj8ewHjV9TN3Otg`,
	"unifiedDesktop": `d44PY95VMKRoyYlGbsr5`,
	"menuToggle": `CHFD27HlQmJL5ruUApiy`,
	"toggleContainer": `xqGIfJ1TkyB9wkKeLsHy`,
	"active": `xxaIlVfjH0PLAN_huz1x`,
	"userMenuDropdown": `ocEleGivLeKHe3q0dCtZ`
};
export default ___CSS_LOADER_EXPORT___;
